import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logoHead from "../images/Logo_head_white.png";
import ContactCard from "../components/ContactCard";

const colors = {
  mainBlue: "#061941",
  cafeNoir: "#583E23",
  carrieban: "#3C6E71",
  isabelline: "#F4F3EE",
  gold: "#F2AF29"
};

const contactOptions = [
  {
    id: 1,
    title: "Contact Devs",
    icon: "💻",
    email: "devs@neuhawk.com",
    description:
      "Get quick technical support, report bugs, or discuss feature requests with our development team.",
    availability: "Monday-Sunday",
    hours: "Available 24/7"
  },
  {
    id: 2,
    title: "Share Feedback",
    icon: "💭",
    type: "feedback",
    description:
      "Help us improve NeuHawk by sharing your experience, suggestions, and ideas with our team.",
    availability: "Always Open",
    hours: "Submit anytime"
  }
];

export default function Contact() {
  const [visibleCards, setVisibleCards] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Stagger the fade-in animations
    contactOptions.forEach((_, index) => {
      setTimeout(() => {
        setVisibleCards(prev => [...prev, index]);
      }, index * 200);
    });
  }, []);

  const handleFeedbackClick = () => {
    navigate("/feedback-form");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: `linear-gradient(120deg, ${colors.mainBlue} 70%, ${colors.gold} 95%, ${colors.gold} 100%)`,
        fontFamily: "Segoe UI, Arial, sans-serif",
        paddingBottom: "7rem"
      }}
    >
      <header
        style={{
          padding: "2.3rem 1rem 1.7rem 1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1.2rem"
        }}
      >
        <img
          src={logoHead}
          alt="NeuHawk logo"
          style={{ height: "64px", width: "64px" }}
        />
        <h1
          style={{
            fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
            fontSize: "2.4rem",
            fontWeight: 800,
            letterSpacing: "2px",
            color: colors.isabelline,
            margin: 0,
            lineHeight: 1.1
          }}
        >
          Contact Us
        </h1>
      </header>

      {/* Subtitle */}
      <div
        style={{
          textAlign: "center",
          maxWidth: "800px",
          margin: "0 auto 3rem auto",
          padding: "0 1rem"
        }}
      >
        <p
          style={{
            fontSize: "1.1rem",
            color: colors.isabelline,
            opacity: 0.9,
            lineHeight: 1.6,
            margin: "0 0 0.5rem 0"
          }}
        >
          Interested in partnerships, technical support, or learning more about
          NeuHawk? We're here to help.
        </p>
        <p
          style={{
            fontSize: "1rem",
            color: colors.isabelline,
            opacity: 0.8,
            lineHeight: 1.6,
            margin: 0
          }}
        >
          Our team can help answer all of your questions:
        </p>
      </div>

      <main
        style={{
          maxWidth: 1300,
          margin: "0 auto",
          padding: "0 1rem"
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "2.5rem",
            justifyContent: "center"
          }}
        >
          {contactOptions.map((option, index) => (
            <ContactCard
              key={option.id}
              option={option}
              isVisible={visibleCards.includes(index)}
              onFeedbackClick={
                option.type === "feedback" ? handleFeedbackClick : undefined
              }
            />
          ))}
        </div>
      </main>
    </div>
  );
}
